import { useNavigate, useParams } from "react-router-dom";
import { Button, Modal, Spinner } from "src/components";
import InvoiceLayout from "src/pages/invoice-master/invoice-layout.component";
import PurpleLeftArrowIcon from "src/features/fields/assets/purple-left-arrow.svg";
import { useToast } from "src/hooks/useToast";
import { RootState } from "src/context/store";
import { useDispatch, useSelector } from "react-redux";
import { downloadInvoice, fetchEinvoicesData } from "src/services/invoice-api";
import EInvoiceReject from "./E-InvoiceReject";
import { useEffect, useState } from "react";
import EInvoiceAccept from "./E-InvoiceAccept";
import { invoiceActions } from "src/context/invoice-slice";
// import { useEventStatus } from "src/hooks/useEventStatus";

const EInvoiceDetails = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { selectedEInvoice } = useSelector((state: RootState) => state.invoice);
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [isAcceptModalOpen, setIsAcceptModalOpen] = useState(false);
  const [tableData, setTableData] = useState<{ label: string; einvoice: string; invoice: string }[]>([]);
  const { einvoice_dtl_id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  // const [irn, setIrn] = useState<string>(" ");
  // const [ewayBillAmount, setEwayBillAmount] = useState<number>(0);
  // const [ewayBillDate, setEwayBillDate] = useState<string>("");
  // const [updatingEInvoice, setUpdatingEInvoice] = useState(false);
  const dispatch = useDispatch();
  // const { withEventCheck } = useEventStatus();

  const stockistInvoiceAttachment = selectedEInvoice?.einvoice_attachment?.attachment_type === "eway" ?
    selectedEInvoice?.stockistInvoiceAttachmentEway :
    selectedEInvoice?.stockistInvoiceAttachment;

  const getEInvoicesData = async (page_size: number, page_number: number) => {
    setIsLoading(true);
    if (!einvoice_dtl_id) return;
    try {
      setIsLoading(true);
      const res = await fetchEinvoicesData({ page_size, page_number, einvoice_dtl_id: einvoice_dtl_id || null });
      dispatch(invoiceActions.setSelectedEInvoice(res?.data?.data?.eInvoices?.[0]));
      setIsLoading(false);
    } catch (error: any) {
      console.error("Error fetching data:", error);
      toast({
        variant: "destructive",
        description: "Failed to load e-invoices",
      });
      setIsLoading(false);
    }
  };

  // const handleSubmit = async () => {
  //   setUpdatingEInvoice(true);
  //   const payload = {
  //     "data":
  //     {
  //       "einvoice_dtl_id": selectedEInvoice?.einvoice_dtl_id,
  //       "einvoice_status": selectedEInvoice?.einvoice_status,
  //       // invoice DTL
  //       "invoice_number": selectedEInvoice?.invoice_number,
  //       "irn_number": irn,
  //       "amount": ewayBillAmount,
  //       "einvoice_ref_type": "IRN",
  //       "invoice_date": selectedEInvoice?.invoice_date,
  //       "irn_date": ewayBillDate,
  //       // // Invoice Attachment
  //       // "total_count": 5,
  //       // "error_count": 0, 
  //       // "my_use": 1,      
  //       // "not_in_use": 1,  
  //       // "document_names": ["doc2.pdf", "dfsg"],
  //       "attachment_type": selectedEInvoice?.einvoice_attachment?.attachment_type,
  //       "buyer_gst": selectedEInvoice?.buyer_gst,
  //       "seller_gst": selectedEInvoice?.seller_gst,
  //       "hsncode": selectedEInvoice?.hsncode,
  //       "item_count": selectedEInvoice?.item_count
  //     }
  //     ,
  //     "primary_key": stockistInvoiceAttachment?.stockist_invoice_attachment_id,
  //     "event_type": "E_INVOICE_EDIT"
  //   }
  //   try {
  //     const response = await eInvoiceEdit(payload);
  //     const res = await withEventCheck(
  //       () => {
  //         return getEInvoicesData(10, 1);
  //       },
  //       response?.data?.data?.eventStreamCreated?.streamId
  //     );
  //     console.log(res);
  //     toast({ description: "E-Invoice updated successfully", variant: "default" });
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     setUpdatingEInvoice(false);
  //   }

  // }

  useEffect(() => {
    if (selectedEInvoice) {
      setTableData([
        {
          label: "Invoice No.",
          invoice: stockistInvoiceAttachment?.stockist_invoice_number,
          einvoice: selectedEInvoice?.invoice_number || "",
        },
        {
          label: "Fuid",
          invoice: stockistInvoiceAttachment?.fuid_no,
          einvoice: selectedEInvoice?.mapped_fuid_number || "",
        },
        {
          label: "Order No",  // MEDVOL: M10-10639 changes
          invoice: stockistInvoiceAttachment?.orderCodes?.map((code: any) => code?.order_code).join(", ") || "",
          einvoice: selectedEInvoice?.orderCodes?.map((code: any) => code?.order_code).join(", ") || "",
        },
        {
          label: "Seller Gst",
          invoice: stockistInvoiceAttachment?.stockist_gst_number,
          einvoice: selectedEInvoice?.seller_gst || "",
        },
        {
          label: "Buyer Gst",
          invoice: stockistInvoiceAttachment?.counter_gst_number,
          einvoice: selectedEInvoice?.buyer_gst || "",
        },
        // MEDVOL: M10-10639 changes
        {
          label: "Invoice Date",
          invoice: stockistInvoiceAttachment?.invoice?.new_invoice_date
            ? `${new Date(stockistInvoiceAttachment?.invoice?.new_invoice_date).toLocaleDateString("en-GB", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}, ${new Date(stockistInvoiceAttachment?.invoice?.new_invoice_date).toLocaleTimeString("en-GB", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })}` : "",
          einvoice: selectedEInvoice?.invoice_date
            ? `${new Date(selectedEInvoice.invoice_date).toLocaleDateString("en-GB", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}, ${new Date(selectedEInvoice.invoice_date).toLocaleTimeString("en-GB", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })}` : "",
        },
         {
          label: "File Upload Date",
          invoice: stockistInvoiceAttachment?.created_date
            ? `${new Date(stockistInvoiceAttachment?.created_date).toLocaleDateString("en-GB", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}, ${new Date(stockistInvoiceAttachment?.created_date).toLocaleTimeString("en-GB", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })}` : "",
          einvoice: selectedEInvoice?.einvoice_attachment?.uploaded_date
            ? `${new Date(selectedEInvoice.einvoice_attachment?.uploaded_date).toLocaleDateString("en-GB", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}, ${new Date(selectedEInvoice.einvoice_attachment?.uploaded_date).toLocaleTimeString("en-GB", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })}` : "",
        },
        {
          label: "Invoice Amount",
          invoice: stockistInvoiceAttachment?.invoice?.net_amount,
          einvoice: selectedEInvoice?.amount || "",
        },
        // MEDVOL: M10-10639 changes
        // {
        //   label: "Stockist Id",
        //   invoice: stockistInvoiceAttachment?.stockist_id,
        //   einvoice: selectedEInvoice?.einvoice_attachment?.stockist_id || "",
        // },
        { label: "QR/IRN", invoice: stockistInvoiceAttachment?.invoice?.e_inv_ref_type, einvoice: selectedEInvoice?.einvoice_ref_type || "" },
        { label: "IRN", invoice: stockistInvoiceAttachment?.invoice?.irn, einvoice: selectedEInvoice?.irn_number || "" },
        { label: "City", invoice: stockistInvoiceAttachment?.state_district_city?.split(",")[2], einvoice: selectedEInvoice?.city || "" },
        { label: "MCI No.", invoice: stockistInvoiceAttachment?.counter_mci_number, einvoice: selectedEInvoice?.mci_no || "" },
        // { label: "DL Number*", invoice: "", einvoice: selectedEInvoice?.dl_number || "" },
        { label: "GST No.*", invoice: stockistInvoiceAttachment?.counter_gst_number, einvoice: selectedEInvoice?.gst_no || "", },
        { label: "GST Status", invoice: stockistInvoiceAttachment?.counter_gst_status == true ? "Active" : "Inactive", einvoice: selectedEInvoice?.gst_status || "" },
      ]);
    }
    // setEwayBillAmount(selectedEInvoice?.amount || 0);
    // setEwayBillDate(selectedEInvoice?.irn_date || "");
    // setIrn(selectedEInvoice?.irn_number || " ");
  }, [selectedEInvoice]);

  useEffect(() => {
    getEInvoicesData(10, 1);
  }, [einvoice_dtl_id]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner />
      </div>
    );
  }

  return (
    <InvoiceLayout>
      <div className="">
        <div className="flex flex-col items-start px-[3.75rem] mt-6 pb-12 shadow-md border-b-[1px] border-b-[#E9E9E9]">
          <Button className="py-2 text-lg text-[#7F56D9]" onClick={() => navigate("/transactions/invoice/2")}>
            <img src={PurpleLeftArrowIcon} alt="back" className="w-3 h-3 mr-3" />
            Back to Invoices
          </Button>
          <h1 className="text-[#49484C] font-bold text-[2rem]">E-Invoices</h1>
        </div>

        <div className="flex px-[3.75rem] mt-10 items-center justify-between gap-x-2">
          <div className="flex items-center gap-x-2">
            <p className="text-2xl font-semibold">{stockistInvoiceAttachment?.company_name}</p>
            <h1
              className={`font-semibold  flex items-center text-xs h-6 px-2 rounded-full`}
              style={{
                backgroundColor:
                  selectedEInvoice?.einvoice_status == "accepted"
                    ? "#D3F6E4"
                    : selectedEInvoice?.einvoice_status == "pending"
                      ? "#FFF9ED"
                      : "#FEE9E8",
                color:
                  selectedEInvoice?.einvoice_status == "accepted"
                    ? "#207A65"
                    : selectedEInvoice?.einvoice_status == "pending"
                      ? "#996B0F"
                      : "#8E1F0B",
              }}
            >
              {selectedEInvoice?.einvoice_status}
            </h1>
          </div>
          <div className="flex items-center p-2 rounded-md bg-[#f1f1f1]">
            <Button
              className="flex items-center px-4 space-x-2 font-normal bg-[#f1f1f1] border-gray-500 rounded-r-none border-r rounded-l-md h-5 hover:text-gray-600 focus:outline-none focus:ring-0"
              onClick={() => {
                if (!stockistInvoiceAttachment?.file_path) {
                  toast({ description: "Invoice not found", variant: "destructive" });
                  return;
                }
                downloadInvoice(stockistInvoiceAttachment?.file_path, stockistInvoiceAttachment?.company_code).then((res: any) => {
                  if (res?.data?.success && res?.data?.data) {
                    window.open(res?.data?.data, "_blank"); // Opens the link in a new tab
                  } else {
                    console.error("Failed to download the invoice.");
                  }
                });
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1M7 8l5 5m0 0l5-5m-5 5V3" />
              </svg>
              <span>Download Invoice</span>
            </Button>
            <Button className="flex items-center px-4 space-x-2 font-normal bg-[#f1f1f1]  border-none rounded-none h-5 hover:text-gray-600 focus:outline-none focus:ring-0">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14M12 5l7 7-7 7" />
              </svg>
              <span>Preview</span>
            </Button>
            <Button className="flex items-center px-4 space-x-2 font-normal bg-[#f1f1f1] border-gray-500 border-l rounded-l-none rounded-r-md h-5 hover:text-gray-600 focus:outline-none focus:ring-0">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M18.364 5.636a9 9 0 11-12.728 0m12.728 0L12 12m0 0l-6.364-6.364" />
              </svg>
              <span>Report an issue</span>
            </Button>
          </div>
        </div>

        <div className="p-6 mt-10 border border-[#D0D0D0] shadow-sm mx-[3.75rem] mb-20 rounded-lg">
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              textAlign: "left",
              border: "1px solid #ccc",
            }}
            className=""
          >
            <thead>
              <tr className="text-sm bg-[#F1F1F1]">
                <th style={{ padding: "10px", borderBottom: "1px solid #ccc" }}></th>
                <th style={{ padding: "10px", borderBottom: "1px solid #ccc" }}>As per Invoice Already Entered</th>
                <th style={{ padding: "10px", borderBottom: "1px solid #ccc" }}>As per Acknowledged Copy</th>
                {/* <th style={{ padding: "10px", borderBottom: "1px solid #ccc" }}>Action</th> */}
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, index) => (
                <tr key={index} className="w-full">
                  <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }} className="w-1/3 text-gray-500">
                    {/* <input type="checkbox" /> */}
                    <span className="ml-2 text-sm font-normal">{row.label}</span>
                  </td>
                  <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }} className="w-1/3 text-sm">
                    {row.invoice}
                  </td>
                  <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }} className="w-1/3 text-sm">
                    {row.einvoice}
                  </td>
                  {/* {selectedEInvoice?.einvoice_attachment?.attachment_type === "eway" ?
                    <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }} className="w-1/3 text-sm">
                      {row.label === "IRN" &&
                        <Input
                          type="text"
                          value={irn}
                          onChange={(e) => { setIrn(e.target.value?.trim()) }}
                        />}
                      {row.label === "E-way Bill Amount" &&
                        <Input
                          type="number"
                          value={ewayBillAmount}
                          onChange={(e) => { setEwayBillAmount(Number(e.target.value?.trim())) }}
                        />}
                      {row.label === "E-way Bill Date" &&
                        <Input
                          type="date"
                          value={ewayBillDate ? ewayBillDate.split("T")[0] : ewayBillDate}
                          max={new Date().toISOString().split("T")[0]}
                          onChange={(e: any) => {
                            const dateValue = e.target.value;
                            const selectedDate = new Date(dateValue);

                            const now = new Date();

                            // Set time using UTC values
                            selectedDate.setUTCHours(now.getUTCHours());
                            selectedDate.setUTCMinutes(now.getUTCMinutes());
                            selectedDate.setUTCSeconds(now.getUTCSeconds());
                            selectedDate.setUTCMilliseconds(now.getUTCMilliseconds());

                            const formattedDate = selectedDate.toISOString(); // This will be in UTC
                            setEwayBillDate(formattedDate);
                          }} />}
                    </td> : <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }} className="w-1/3 text-sm"></td>} */}
                </tr>
              ))}
            </tbody>
          </table>
          <div className="flex items-center justify-end mt-14 gap-x-2">
            {selectedEInvoice?.einvoice_status === "pending" && <div className="flex gap-x-2">
              <Button
                className="font-normal px-4 py-2 bg-gray-200 border border-gray-300"
                onClick={() => {
                  setIsRejectModalOpen(true);
                }}
              // disabled={updatingEInvoice}
              >
                Reject
              </Button>
              <Button
                // disabled={updatingEInvoice}
                className="font-normal px-4 py-2 text-white bg-[#8051FF]" onClick={() => setIsAcceptModalOpen(true)}>
                Accept
              </Button>
            </div>}
            {/* <div>
              <Button
                disabled={updatingEInvoice}
                isLoading={updatingEInvoice}
                loaderSize="small"
                onClick={handleSubmit}
                className="font-normal px-4 py-2 text-white bg-[#8051FF]"
              >
                Submit
              </Button>
            </div> */}
          </div>
        </div>
        <Modal isOpen={isRejectModalOpen} onCloseModal={() => setIsRejectModalOpen(false)} isHeader={false}>
          <EInvoiceReject
            onSuccess={() => {
              setIsRejectModalOpen(false);
              getEInvoicesData(10, 1);
            }}
            eInvoiceData={selectedEInvoice}
            primary_key={stockistInvoiceAttachment?.stockist_invoice_attachment_id}
            einvoice_dtl_id={selectedEInvoice?.einvoice_dtl_id}
            onCloseModal={() => setIsRejectModalOpen(false)}
          />
        </Modal>
        <Modal isOpen={isAcceptModalOpen} onCloseModal={() => setIsAcceptModalOpen(false)} isHeader={false}>
          <EInvoiceAccept
            onSuccess={() => {
              setIsAcceptModalOpen(false);
              getEInvoicesData(10, 1);
            }}
            eInvoiceData={selectedEInvoice}
            primary_key={stockistInvoiceAttachment?.stockist_invoice_attachment_id}
            einvoice_dtl_id={selectedEInvoice?.einvoice_dtl_id}
            onCloseModal={() => setIsAcceptModalOpen(false)}
          />
        </Modal>
      </div>
    </InvoiceLayout>
  );
};

export default EInvoiceDetails;
